import { find } from 'es-toolkit/compat';
import { useCallback, useMemo } from 'react';

import { applyPanelRnaProbeDisplayNames, getPanelRnaProbeDisplayNames } from 'utils/multiplex/panelChannelPresentation';
import { useStainTypeOptions } from 'utils/queryHooks/uiConstantsHooks';
import useStudy from 'utils/useStudy';

export const useStainTypeIdToDisplayName = (studyId?: string, ...props: Parameters<typeof useStainTypeOptions>) => {
  const { stainTypeOptions, isLoadingStainTypeOptions } = useStainTypeOptions(...props);
  const { study } = useStudy(studyId, { enabled: Boolean(studyId) });
  const panelRnaProbeDisplayNames = useMemo(
    () => getPanelRnaProbeDisplayNames(study?.settings?.multiplexPanels),
    [study?.settings?.multiplexPanels]
  );
  const overriddenStainTypeOptions = useMemo(
    () => applyPanelRnaProbeDisplayNames(stainTypeOptions, panelRnaProbeDisplayNames),
    [stainTypeOptions, panelRnaProbeDisplayNames]
  );
  const stainTypeIdToDisplayName = useCallback(
    (stainTypeId: string) =>
      panelRnaProbeDisplayNames[stainTypeId] ||
      find(overriddenStainTypeOptions, (stain) => stain.id === stainTypeId && !stain.rna)?.displayName ||
      stainTypeId,
    [overriddenStainTypeOptions, panelRnaProbeDisplayNames]
  );
  return {
    stainTypeOptions: overriddenStainTypeOptions,
    isLoadingStainTypeOptions,
    stainTypeIdToDisplayName,
  };
};
